var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.6665C15 10.4165 10 14.1665 10 14.1665C10 14.1665 5 10.4165 5 6.6665C5 5.34042 5.52678 4.06865 6.46447 3.13097C7.40215 2.19329 8.67392 1.6665 10 1.6665C11.3261 1.6665 12.5979 2.19329 13.5355 3.13097C14.4732 4.06865 15 5.34042 15 6.6665Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 8.33333C10.9206 8.33333 11.6668 7.58714 11.6668 6.66667C11.6668 5.74619 10.9206 5 10.0002 5C9.07969 5 8.3335 5.74619 8.3335 6.66667C8.3335 7.58714 9.07969 8.33333 10.0002 8.33333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36258 11.6665H4.16675C3.99719 11.6757 3.8345 11.7366 3.70047 11.8408C3.56643 11.9451 3.46744 12.0878 3.41675 12.2498L1.75008 17.2498C1.66675 17.3332 1.66675 17.4165 1.66675 17.4998C1.66675 17.9998 2.00008 18.3332 2.50008 18.3332H17.5001C18.0001 18.3332 18.3334 17.9998 18.3334 17.4998C18.3334 17.4165 18.3334 17.3332 18.2501 17.2498L16.5834 12.2498C16.5327 12.0878 16.4337 11.9451 16.2997 11.8408C16.1657 11.7366 16.003 11.6757 15.8334 11.6665H12.6376",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.344dbb761eb9a4372f3070be725b7ec7.svg";
export { ForwardRef as ReactComponent };